import { createContext } from 'react';
import { UseSearchData } from './dataProvider';

export interface SearchResultContextValue extends UseSearchData {
    onClose: () => void;
}

export const SearchResultContext = createContext<SearchResultContextValue>({
    onClose: () => {
        /* noop */
    },
    isLoaded: false,
    isLoading: false,
    query: '',
});

SearchResultContext.displayName = 'SearchResultContext';

export const SearchResultContextProvider = SearchResultContext.Provider;
